import { render, staticRenderFns } from "./category-money.vue?vue&type=template&id=ad2f5520&scoped=true&"
import script from "./category-money.vue?vue&type=script&lang=js&"
export * from "./category-money.vue?vue&type=script&lang=js&"
import style0 from "./category-money.vue?vue&type=style&index=0&id=ad2f5520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f5520",
  null
  
)

component.options.__file = "category-money.vue"
export default component.exports